var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"user-level-points-progress-bar"},[_c('div',{staticClass:"progress-bar",style:({ width: `${_vm.percentage}%` })}),(_vm.showNewPointsProgress)?_c('div',{staticClass:"new-points",style:({ width: `${_vm.percentage}%` })}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }